// helpers
import NFA from 'shared/helpers/analytics/NFAnalytics';
import DTM from 'shared/helpers/DTM';

// constants
import { TRACK_TYPE } from 'shared/helpers/analytics/constants';

export const onSelectedTabRender = (tabName: string) => {
  DTM.updateDatalayer({ selectedBottomNavState: tabName });
};

export const onTabClick = ({
  storeName,
  tabName,
  title,
}: {
  storeName: string;
  tabName: string;
  title: string;
}) => {
  // todo mp: remove after omniture removal
  // DTM.track('bottom-nav-tab-click', { storeName, tabName });
  NFA.updateDatalayerBeforeNext({ bottomNavClicked: title }, TRACK_TYPE.PAGELOAD);
  NFA.track({
    event: 'bottom_nav_clicked',
    data: { bottomNavOption: title },
    dtmData: { storeName, tabName },
  });
};
